export class ApiCachedRequestResponse<T> {
	constructor(public value: T, public isFromCache: boolean) {	}
}
